import React, { useContext, useEffect, useState } from "react";
import {
	Box,
	Typography,
	IconButton,
	Menu,
	MenuItem,
	Avatar,
	getLuminance,
	Button,
} from "@mui/material";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../contexts/UserContext";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { CreatorContext } from "../../contexts/CreatorContext";

function Navbar() {
	const { t } = useTranslation();
	const { creator } = useContext(CreatorContext);
	const navigate = useNavigate();
	const { basePath } = useParams();
	const location = useLocation();
	const { user, getUser, logout } = useContext(UserContext);

	const [anchorEl, setAnchorEl] = useState(null);

	useEffect(() => {
		if (!user) {
			getUser(); // Si no hay usuario, llamamos a getUser
		}
	}, [user, getUser]);

	const handleLogin = () => {
		navigate(`/${basePath}/login`);
	};

	const handleLogout = () => {
		if (!creator.isCreator) {
			logout();
			navigate(`/${basePath}/`);
			setAnchorEl(null);
		}
	};

	const handleMenuOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				padding: "10px 20px",
				backgroundColor: creator?.backgroundColor || "#f8f8f8",
				color:
					getLuminance(creator?.backgroundColor ?? "#f8f8f8") >= 0.5
						? "#000000"
						: "#FFFFFF",
				/*borderBottom: "1px solid #ddd",*/
			}}
		>
			{/* Puedes agregar un logo o título aquí */}
			<Typography variant="h6" sx={{ fontWeight: 600 }}></Typography>

			{/* Opciones para el usuario */}
			{user ? (
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<Typography
						variant="body1"
						sx={{ marginRight: "20px", fontSize: "14px", fontWeight: 600 }}
					>
						{t("helloUser", { userName: user.name })} - {user.points}{" "}
						{t("points")}
					</Typography>

					{/* Avatar o icono de perfil para abrir menú desplegable */}
					<IconButton onClick={handleMenuOpen} sx={{ padding: 0 }}>
						<Avatar
							style={{
								width: 30,
								height: 30,
								backgroundColor: creator?.mainColor || "#43BD98",
								color:
									getLuminance(creator?.mainColor ?? "#43BD98") >= 0.5
										? "#000000"
										: "#FFFFFF",
							}}
						>
							<AccountCircleIcon style={{ fontSize: "16px" }} />
						</Avatar>
					</IconButton>

					{/* Menú desplegable */}
					<Menu
						anchorEl={anchorEl}
						open={Boolean(anchorEl)}
						onClose={handleMenuClose}
						slotProps={{
							paper: {
								sx: {
									backgroundColor: "#f8f8f8",
									boxShadow: "none", // Remove shadow specifically for this Menu
								},
							},
						}}
					>
						<MenuItem
							onClick={() => {
								navigate(`/${basePath}/appointments`);
								handleMenuClose();
							}}
							sx={{ fontSize: "14px" }}
						>
							<CalendarTodayIcon sx={{ marginRight: 1, fontSize: "12px" }} />
							{t("yourAppointments")}
						</MenuItem>
						<MenuItem
							disabled={creator.isCreator}
							onClick={handleLogout}
							sx={{ fontSize: "14px" }}
						>
							<ExitToAppIcon sx={{ marginRight: 1, fontSize: "14px" }} />
							{t("logout")}
						</MenuItem>
					</Menu>
				</Box>
			) : (
				<></>
			)}

			{/*<Box sx={{ display: "flex", alignItems: "center" }}>
				
			{location.pathname.includes("login") ? (
				<Button
					variant="outlined"
					color="primary"
					onClick={() => navigate(`/${basePath}/`)}
					sx={{
						padding: "8px 24px",
						fontSize: "14px",
						borderRadius: "6px",
						boxShadow: "none",
					}}
				>
					{t("back")}
				</Button>
			) : (
				<Button
					variant="outlined"
					color="primary"
					onClick={handleLogin}
					sx={{
						padding: "8px 24px",
						fontSize: "14px",
						borderRadius: "6px",
						boxShadow: "none",
					}}
				>
					{t("initSesion")}
				</Button>
			)}
		</Box> */}
		</Box>
	);
}

export default Navbar;
